export default __webpack_public_path__ + "static/media/Pretendard-Regular.ab56c53f.woff";